import { render, staticRenderFns } from "./AddAffiliate.vue?vue&type=template&id=f819a98a&scoped=true&"
import script from "./AddAffiliate.vue?vue&type=script&lang=js&"
export * from "./AddAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./AddAffiliate.vue?vue&type=style&index=0&id=f819a98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f819a98a",
  null
  
)

export default component.exports